/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { AbstractRestService, identity, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { LetterDto } from '../../letters/letter.dto';
import { LetterMapper } from '../../letters/letter.mapper';
import { DocInfoDto } from './job-leters-docs.dto';
import { DocInfoMapper } from './job-leters-docs.mapper';

@Injectable()
export class JobLetterDocRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  get(jobId: ID): Observable<string[]> {
    return this.httpGet(
      `${this.bp}/jobs/${jobId}/docs`,
      identity(),
    );
  }

  produce(jobId: ID, docInfo: DocInfoDto): Observable<LetterDto> {
    return this.httpPut(
      `${this.bp}/jobs/${jobId}/docs`,
      docInfo,
      DocInfoMapper,
      LetterMapper,
    );
  }
}
